/**
 * Service/DsVpg Controller
 *
 * Displays information about a Draas vpg
 */

// the constructor for this object
function ServiceDsVpgController() { }

// the object
ServiceDsVpgController.prototype = {
    constructor: ServiceDsVpgController,
    
    // the zerto vpg id
    vpgId: false,
    
    // the base order id
    baseOrderId: false,
    
    // store the vms count chart object here
    vmsCountChart: false,
    
    // store the rpo chart object here
    rpoChart: false,
    
    // store the storage stats chart object here
    storageChart: false,
    
    // this contains the pagination object
    pagination: false,
    
    // the number of order per page
    perPage: 10,
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastSubmittedData: {},
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // set up the pagination
        this._setupPagination();
        
        // register charts 
        this._registerCharts();
        
        PortalHelper.debugMessage('Service Draas VPG Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the pagination events
        this.pagination.init();
    
        // get and populate the order
        this._getOrder();
        
        // get/populate the Draas specific order info
        this._getDsVpg();
        
        // get the vpgs vms
        this._getDsVpgVms();
        
        // get the vpg stats
        this._getVpgStats();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Service Draas VPG Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the product cd
        if (segments.length == 2) {
            this.baseOrderId = segments[0];
            this.vpgId = segments[1];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // create the pagination object
    _setupPagination: function()
    {
        var pagination = new PortalPagination;
        pagination.perPage = this.perPage;
        pagination.paginationSelector = '#vms-pagination';
        pagination.contentSelector = '#vms-table';
        pagination.searchSelector = '#vms-search';
        pagination.searchColumn = 'search_all';
        pagination.eventCallback = PortalMain.ServiceDsVpgController._getDsVpgVms;
        PortalMain.ServiceDsVpgController.pagination = pagination;
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#range-selection-dropdown');
        $('#range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceDsVpgController._updateChartRange(
                this.dataset.timelineRangeSeconds
            );
            
            PortalMain.ServiceDsVpgController._updateSelectedRange(this);
        });
        
        // download the csv file of the vms clicked
        $('.download-vms').on('click', function(e) {
            e.preventDefault();
            
            PortalMain.ServiceDsVpgController._downloadVms();
        });
    },
    
    // register the charts
    _registerCharts: function()
    {
        // new chart for rpo history
        var vmsCountChart = new PortalChart;
        vmsCountChart.elementId = 'vms-count-chart';
        vmsCountChart.type = 'line';
        vmsCountChart.dataFormat = 'number';
        vmsCountChart.columns = [];
        this.vmsCountChart = vmsCountChart;
        
        // new chart for rpo history
        var rpoChart = new PortalChart;
        rpoChart.elementId = 'rpo-chart';
        rpoChart.type = 'line';
        rpoChart.dataFormat = 'number';
        rpoChart.columns = [];
        this.rpoChart = rpoChart;
        
        // new chart for storage stats history
        var storageChart = new PortalChart;
        storageChart.elementId = 'storage-chart';
        storageChart.type = 'line';
        storageChart.dataFormat = 'bytes';
        storageChart.columns = [];
        storageChart.dataPower = 1024;
        this.storageChart = storageChart;
    },
    
    // get the order from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        PortalMain.ServiceIndexController.showOrderLink = true;
        
        PortalMain.ServiceIndexController._getOrder();
    },
    
    // get BaaS specific order info (usage information)
    _getDsVpg: function()
    {
        var DsVpgRequest = new PortalRequest;
        DsVpgRequest.makeRequest(
            '/orders-ds/get-vpg',
            {
                vpgId: this.vpgId,
            },
            function(data) {
                PortalMain.ServiceDsVpgController._populateVpgInfo(data);
                
                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#vpg-details', false);
                PortalHelper.loadingOverlay('.stats', false);
            }
        )
    },
    
    // retrieves the vms of the draas order
    _getDsVpgVms: function()
    { 
        // get the submission data from the pagination object
        var submissionData = PortalMain.ServiceDsVpgController.pagination.getBaseSubmissionData();
        
        // set up the data to be submitted
        submissionData.baseOrderId = PortalMain.ServiceDsVpgController.baseOrderId;
        submissionData.vpgId = PortalMain.ServiceDsVpgController.vpgId;
        
        // make sure the new request isn't the same as the previous one
        if (JSON.stringify(submissionData) == JSON.stringify(PortalMain.ServiceDsVpgController.lastSubmittedData)) {
            PortalMain.ServiceDsVpgController.pagination.showPagination();
            return;
        }
        PortalMain.ServiceDsVpgController.lastSubmittedData = submissionData;
        
        // make the request
        var dsVmsRequest = new PortalRequest;
        dsVmsRequest.pageNumber = submissionData.page;
        dsVmsRequest.makeRequest(
            '/orders-ds/get-vms',
            submissionData,
            function(data) {
                
                //handle pagination 
                PortalMain.ServiceDsVpgController.pagination.updatePagination(data);
                PortalMain.ServiceDsVpgController.pagination.showPagination();
                
                // get the last pagination event
                var lastEvent = PortalMain.ServiceDsVpgController.pagination.lastEvent;
                
                // fill the vms table
                PortalMain.ServiceDsVpgController._populateVmsTable(data, lastEvent);
            }
        );
    },
    
    // fill in the vpg info
    _populateVpgInfo: function(vpg)
    {
        // set the VPG name
        $('#vpg-details .vpg-name').html(vpg.vpg_name);
        
        // set the vms count
        $('#vpg-vms-count').text(vpg.vms_count);
        
        // set the rpo
        $('#vpg-rpo').text(vpg.actual_rpo);
        
        // set the provisioned storage
        var provisionedStorage = PortalHelper.formatBytes(vpg.provisioned_storage, 'GB', null, null, 1024);
        $('#vpg-provisioned-storage span:nth-child(1)').text(provisionedStorage[0]);
        $('#vpg-provisioned-storage span:nth-child(2)').text(provisionedStorage[1]);
        
        // set the used storage
        var usedStorage = PortalHelper.formatBytes(vpg.used_storage, 'GB', null, null, 1024);
        $('#vpg-used-storage span:nth-child(1)').text(usedStorage[0]);
        $('#vpg-used-storage span:nth-child(2)').text(usedStorage[1]);
    },
    
    // populate the orders table
    _populateVmsTable: function(vmsData, lastPaginationEvent)
    {    
        var vms = vmsData.data;
        
        // clear the old vms
        if (lastPaginationEvent != 'more') {
            $('#vms-table tbody tr:not(.clone-source)').remove();
        }
        
        // add the new vms to the DOM
        for (var i in vms) {
            var vm = vms[i];
            var newEntry = $('#vms-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the vm name
            $('.vm-name', newEntry).html(vm.vm_name);
            
            // apply the vm link
            var vmLink = PortalConfig.portalUrl;
            vmLink += '/service/ds-vm';
            vmLink += '/' + this.baseOrderId;
            vmLink += '/' + vm.zerto_vm_id;
            $('.vm-name', newEntry).attr('href', vmLink);
            
            // apply the actual rpo
            $('.actual-rpo', newEntry).html(vm.actual_rpo);
            
            // apply the journal size
            var journalSize = PortalHelper.formatBytes(vm.journal_size_used, 'GB', null, null, 1024);
            $('.journal-size', newEntry).html(journalSize);
            
            // apply the provisioned storage
            var provisionedStorage = PortalHelper.formatBytes(vm.used_storage, 'GB', null, null, 1024);
            $('.protected-disk', newEntry).html(provisionedStorage);
            
            // apply the used storage
            var totalStorage = PortalHelper.formatBytes(vm.used_storage + vm.journal_size_used, 'GB', null, null, 1024);
            $('.total-storage', newEntry).html(totalStorage);
            
            // add to to the table
            $('#vms-table tbody').append(newEntry);
        }
        
    },
    
    // retrieves the timeline vpg stats
    _getVpgStats: function(startDate, endDate)
    {
        // defaulting to 1 week range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();
            
            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }
        
        var vpgStatsRequest = new PortalRequest;
        vpgStatsRequest.makeRequest(
            '/orders-ds/get-vpg-stats',
            {
                vpgId: this.vpgId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data) {
                PortalMain.ServiceDsVpgController._populateVmsCountChart(data, startDate, endDate);
                PortalMain.ServiceDsVpgController._populateRpoChart(data, startDate, endDate);
                PortalMain.ServiceDsVpgController._populateStorageChart(data, startDate, endDate);
            }
        );
    },
    
    // sets up the vms count graph, populating columns and data
    _populateVmsCountChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'VM Count'
        ]);
        
        this.vmsCountChart.minDate = startDate;
        this.vmsCountChart.maxDate = endDate;
        // resetting columns first
        this.vmsCountChart.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.vmsCountChart.columns[i] = ['date', currentField];
            } else {
                this.vmsCountChart.columns[i] = ['number', currentField];
            }
        }
        
        if(chartData.length == 1) {
            $('#vms-count-chart').text("No data available for this period.");
        } else {
            this.vmsCountChart.data = chartData;
            this.vmsCountChart.draw();
        }
        PortalHelper.loadingOverlay('#vms-count-chart', false);        
    },
    
    // sets up the rpo graph, populating columns and data
    _populateRpoChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'RPO'
        ]);
        
        this.rpoChart.minDate = startDate;
        this.rpoChart.maxDate = endDate;
        // resetting columns first
        this.rpoChart.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.rpoChart.columns[i] = ['date', currentField];
            } else {
                this.rpoChart.columns[i] = ['number', currentField];
            }
        }
        
        if(chartData.length == 1) {
            $('#rpo-chart').text("No data available for this period.");
        } else {
            this.rpoChart.data = chartData;
            this.rpoChart.draw();
        }
        PortalHelper.loadingOverlay('#rpo-chart', false);        
    },
    
    // sets up the storage graph, populating columns and data
    _populateStorageChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'Journal Size',
            'Protected Disk',
            'Total Storage'
        ]);
        
        this.storageChart.minDate = startDate;
        this.storageChart.maxDate = endDate;
        // resetting columns first
        this.storageChart.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.storageChart.columns[i] = ['date', currentField];
            } else {
                this.storageChart.columns[i] = ['number', currentField];
            }
        }
        
        if(chartData.length == 1) {
            $('#storage-chart').text("No data available for this period.");
        } else {
            this.storageChart.data = chartData;
            this.storageChart.draw();
        }
        PortalHelper.loadingOverlay('#storage-chart', false);        
    },
    
    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#vms-count-chart', true);
        PortalHelper.loadingOverlay('#rpo-chart', true);
        PortalHelper.loadingOverlay('#storage-chart', true);
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime() 
            - (dateRangeSeconds * 1000)
        );
        
        this._getVpgStats(startDate, endDate);
    },
    
    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('.selection-text').text(selectedElementText);
    },
    
    // download the vms csv from the api
    _downloadVms: function()
    {
        PortalHelper.loadingOverlay('#vms-pagination', true);
        
        // get the submission data from the pagination object
        var submissionData = PortalMain.ServiceDsVpgController.pagination.getBaseSubmissionData();
        
        // include the base order id
        submissionData.baseOrderId = PortalMain.ServiceDsVpgController.baseOrderId;
        submissionData.vpgId = PortalMain.ServiceDsVpgController.vpgId;
        
        // make the request
        var downloadVmsRequest = new PortalRequest;
        downloadVmsRequest.pageNumber = submissionData.page;
        downloadVmsRequest.isBinary = true;
        downloadVmsRequest.makeRequest(
            '/orders-ds/download-vms',
            submissionData,
            function(data) {
                PortalHelper.loadingOverlay('#vms-pagination', false);
                
                // build the file name
                var fileName = $('.order-number .value').html();
                fileName += '-' + $('.vpg-name').html();
                fileName += '-VMs';
                fileName = fileName.replace(/ /g,'-');
                fileName = fileName.replace(/--/g,'');
                fileName += '.csv';
                
                // download the file
                PortalHelper.downloadFile(data, fileName);
            },
            function() {
                PortalHelper.loadingOverlay('#vms-pagination', false);
                PortalHelper.openErrorPopup(
                    'Download Error',
                    'There was an error downloading this file. This may be because there are no VMs to download. Change your search settings, and try again.'
                );
            }
        );
    },
}